var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUnarchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07875 3.76449L5.48469 4.17011L6.43611 3.21856C6.9594 2.6952 7.39388 2.26699 7.4016 2.26699C7.40935 2.26699 7.41567 5.47834 7.41567 7.89001H8.57253C8.57253 5.47834 8.57885 2.26699 8.5866 2.26699C8.59432 2.26699 9.0288 2.6952 9.55209 3.21856L10.5035 4.17011L10.9095 3.76449C11.1327 3.5414 11.3154 3.35037 11.3154 3.33999C11.3154 3.32964 10.5681 2.57389 9.65475 1.66057L7.9941 0L6.33345 1.66057C5.42009 2.57389 4.6728 3.32964 4.6728 3.33999C4.6728 3.35037 4.85547 3.5414 5.07875 3.76449Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00001 3.00002H0V7.89101H0.739337V15.8547H15.2607V7.89101H16V3.00002H12V4.19433H14.8057V6.6967H9.66668V7.89101H14.0664V14.6604H1.93365V7.89101H6.33334V6.6967H1.19431V4.19433H4.00001V3.00002Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.78199 10.8484H10.218V9.673H5.78199V10.8484Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnarchive);
export default __webpack_public_path__ + "static/media/icon--unarchive.4f0ccfdbfec8b6fc8924c4b9f17aabec.svg";
export { ForwardRef as ReactComponent };